// @flow
import type {
  ImportJobsPopupOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<ImportJobsPopupOperation>,
})
